import { seoRoutes } from '../seoRoutes';

export const isSeoUrl = pathname => {
    return seoRoutes.some(prefix => {
        return pathname.startsWith(prefix);
    });
};
